import React, { useState } from 'react'
import { RefreshCw, Zap } from 'lucide-react'
import NewsTab from './components/NewsTab'

export default function App() {
  const [autoRefresh, setAutoRefresh] = useState(true)

  return (
    <div className="min-h-screen bg-black">
      {/* Ambient glow */}
      <div className="fixed inset-0 bg-gradient-to-br from-gray-900 via-black to-gray-900 pointer-events-none" />
      <div className="fixed top-0 left-1/2 -translate-x-1/2 w-[400px] md:w-[600px] h-[200px] md:h-[300px] rounded-full blur-[100px] md:blur-[120px] opacity-15 md:opacity-20 pointer-events-none bg-emerald-500" />

      <div className="relative">
        {/* Sticky header - compact on mobile */}
        <header className="sticky-header safe-top border-b border-white/5">
          <div className="max-w-7xl mx-auto px-3 md:px-4 py-2.5 md:py-4">
            <div className="flex items-center justify-between">
              {/* Logo - compact on mobile */}
              <div className="flex items-center gap-2 md:gap-3">
                <div className="relative">
                  <div className="w-8 h-8 md:w-12 md:h-12 bg-gradient-to-br from-emerald-500 via-cyan-500 to-fuchsia-500 rounded-lg md:rounded-2xl flex items-center justify-center">
                    <Zap className="w-4 h-4 md:w-6 md:h-6 text-black" />
                  </div>
                  <div className="absolute -inset-1 bg-gradient-to-br from-emerald-500 via-cyan-500 to-fuchsia-500 rounded-lg md:rounded-2xl blur opacity-25" />
                </div>
                <div>
                  <h1 className="text-base md:text-2xl font-black tracking-tighter text-white leading-none">1020</h1>
                  <p className="text-[8px] md:text-[10px] font-medium tracking-[0.15em] md:tracking-[0.2em] text-gray-500 uppercase leading-none mt-0.5">Dashboard</p>
                </div>
              </div>

              {/* Controls */}
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setAutoRefresh(!autoRefresh)}
                  className={`
                    relative touch-target flex items-center justify-center gap-1.5 md:gap-2 px-3 md:px-4 h-9 md:h-auto md:py-2 rounded-full text-[11px] md:text-sm font-semibold
                    transition-all duration-300 overflow-hidden
                    ${autoRefresh
                      ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30'
                      : 'bg-gray-800 text-gray-400 border border-gray-700'
                    }
                  `}
                >
                  <RefreshCw className={`w-3.5 h-3.5 md:w-4 md:h-4 ${autoRefresh ? 'animate-spin' : ''}`} />
                  <span>{autoRefresh ? 'LIVE' : 'PAUSED'}</span>
                  {autoRefresh && (
                    <span className="absolute top-1 right-1 w-1.5 h-1.5 bg-emerald-400 rounded-full animate-ping" />
                  )}
                </button>
              </div>
            </div>
          </div>
        </header>

        {/* Main content - extra bottom padding on mobile for tab bar */}
        <main className="max-w-7xl mx-auto px-3 md:px-4 py-4 md:py-8 pb-24 md:pb-8">
          <NewsTab autoRefresh={autoRefresh} />
        </main>

        {/* Footer - hidden on mobile */}
        <footer className="hidden md:block border-t border-white/5 py-6 mt-12">
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex items-center justify-between text-xs text-gray-600">
              <span>1020 Dashboard</span>
              <span className="flex items-center gap-2">
                <span className={`w-1.5 h-1.5 rounded-full ${autoRefresh ? 'bg-emerald-500' : 'bg-gray-500'}`} />
                {autoRefresh ? 'Live updates enabled' : 'Updates paused'}
              </span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  )
}
